module.exports = __webpack_public_path__ + "09b4c30f.svg";